/**
 * @file index.tsx
 *
 * @fileoverview Shows a placeholder when a organization search page is loading.
 */

import Grid from "../../../../02-atoms/06-layout/04-grid";
import Cell from "../../../../02-atoms/06-layout/04-grid/01-cell";
import Spacing from "../../../../02-atoms/06-layout/07-spacing";
import Main from "../../../../02-atoms/06-layout/09-main";
import SearchFormPlaceholder from "../../07-search-form";
import { OrganizationTeaserPlaceholder } from "../03-teaser";

/**
 * Placeholder skeleton for organization search for when page is loading.
 * Skeletons help provide some guidance to the user for
 * what the page will have while content is loading.
 */
export const OrganizationSearchPlaceholder = () => {
  return (
    <div>
      <Spacing size="medium" />
      <Main size="small">
        <SearchFormPlaceholder />
      </Main>
      <Grid columns={[1, 2, 4]}>
        {Array(12)
          .fill("")
          .map((i) => (
            <Cell key={i} display="grid">
              <OrganizationTeaserPlaceholder />
            </Cell>
          ))}
      </Grid>
    </div>
  );
};
export default OrganizationSearchPlaceholder;
